<template>
  <div id="app">
    <router-view/>
    <div class="qidian" :class="{'ycqd' : !showQQ}">
          <div class="qq_qidian"></div>
          <div v-if="showQQ" @click="yincangQQ" class="yincangBtn">点击隐藏</div>
          <div v-else  @click="xianshiQQ" class="xianshiBtn">在线客服</div>
    </div>
  </div>
</template>

<script>
// import '@/utils/ban'
// import { cwqr } from "@/api/api";

export default {
    components:{

    },
    data() {
        return {
          showQQ:false,
          notifications:[],
          timer: null, // 定时器 id
          
        }
    },
    methods: {
      loadQQScript() {
        const existingScript = document.getElementById('qd3009079785252efa856fc49c7cf37e317449fc4369');
        if (existingScript) return; // 避免重复加载
        
        const script = document.createElement('script');
        script.id = 'qd3009079785252efa856fc49c7cf37e317449fc4369';
        script.src = 'https://wp.qiye.qq.com/qidian/3009079785/252efa856fc49c7cf37e317449fc4369';
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        
        var div = document.querySelector('.qq_qidian');
        div.appendChild(script);
      },
      yincangQQ(){
        this.showQQ = false
        // 移除script标签
        const script = document.getElementById('qd3009079785252efa856fc49c7cf37e317449fc4369');
        if (script) {
          script.remove();
        }

        // const scriptA = document.querySelector('.qidian_wpa_img');
        // if (scriptA) {
        //   scriptA.remove();
        // }

        const scriptList = document.querySelectorAll('.qidian_wpa_img');

        // 遍历并删除每个 qidian_wpa_img 元素
        scriptList.forEach(element => {
          element.remove();
        });
      },
      xianshiQQ(){
        this.showQQ=true
        this.loadQQScript()
      },
      // dingshi() {
      //   let that = this

      //   // 定时器定时调用接口获取未读舱位确认消息
      //   that.timer = setInterval(() => {
      //     this.open()
      //   }, 5000);

      // },
      // async open() {
      //   try {
      //     let that = this
      //     let headers = {
      //         'token':localStorage.getItem('token')
      //     }
      //     const res = await cwqr(headers)
      //     if(res.code==1){
      //       if(res.data.record_id>0){
      //         const notify =  this.$notify({
      //           title: '舱位确认',
      //           message: '您有一条新的消息待查看，点击查看',
      //           duration: 4000,
      //           offset: 50,
      //           position: 'bottom-right',
      //           onClick: function() {  
      //             that.$router.push({
      //               name:'messageDeatilHt',
      //               query:{
      //                   id:res.data.record_id
      //               },
      //               params:{
      //                   id:res.data.record_id
      //               }
      //             })
      //             sessionStorage.setItem("menu", '6');
      //             notify.close();  // 点击关闭
      //           }  
      //         });
        
      //       }
      //     }
       
      //   } catch (error) {
      //     console.log(error,'失败');
      //   }
      // },
    },
    mounted(){
      // this.loadQQScript()
        
      // 判断是否是供应商  判断供应商的认证状态
      // if(localStorage.getItem('userInfo')){
      //   let user = JSON.parse(localStorage.getItem('userInfo'))
      //   if(user.supplier_id>0 && user.supplier_is_authentication==2){
      //     this.dingshi()
      //   }
      // }
     


      // console.log(11111,'获取当前设备信息',navigator.userAgent,navigator);

      let nav = navigator.userAgent
      if(nav.indexOf('Android') != -1 || nav.indexOf('iPhone') != -1 || nav.indexOf('iPad') != -1 || nav.indexOf('iPod') != -1){
        window.location.href = 'https://serve.dhcang.com/web/'  // 移动端
      }
      // else if(nav.indexOf('Windows') != -1 || nav.indexOf('Macintosh') != -1){
      //   window.location.href = 'https://serve.dhcang.com/'  // PC端
      // }

        // 移动端
        // navigator.indexOf('Android') != -1 ||
        // navigator.indexOf('iPhone') != -1 ||
        // navigator.indexOf('iPad') != -1 ||
        // navigator.indexOf('iPod') != -1
        // PC端
        // v-if="navigator.indexOf('Windows') != -1 || navigator.indexOf('Macintosh') != -1"

      
    }
}
</script>


<style lang="scss">
#app,body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  background: #F9F9F9;
}


.el-message {
  z-index: 9999 !important; /* 或者更高的值 */
}

.qidian{
  position: fixed;
  bottom: 226PX;
  right: 30PX;
  text-align: center;
  background: #fff;
  color: #606260;
  border-radius: 4PX;
  font-size: 14PX;
  z-index: 1999999999;
  
  .qq_qidian{
    width: 98PX;
    height: 125PX;
  }
  .yincangBtn{
    cursor: pointer;
  }
  .xianshiBtn{
    background: #EEE;
    border-radius: 4PX;
    width: 20PX;
    cursor: pointer;
    color: #606260;
  }
}

.ycqd{
  width: 20PX;
  background:none;
}
</style>
